
import Vue from 'vue'
import BaseLayout from '@/components/BaseLayout.vue'
import TheSidebar from '@/views/company/TheSidebar.vue'

export type DataType = {
  hide: boolean;
}

export default Vue.extend({
  name: 'TheTemplate',

  components: {
    BaseLayout,
    TheSidebar
  },

  data(): DataType {
    return {
      hide: false,
    }
  },

  computed: {
    arrowStyleText(): string {
      if (this.hide) {
        return 'transform: rotateZ(90deg);'
      }
      return 'transform: rotateZ(-90deg);'
    }
  },

  methods: {
    toggleHide(): void {
      this.hide = !this.hide
    }
  }
})
